var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skill"},[_c('widget-title',{attrs:{"title":"专业技能"}}),_vm._l((_vm.skills),function(skill,index){return _c('progress-bar',{key:index,attrs:{"title":skill.title,"color":skill.color,"progress":skill.progress}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }